import React, { useCallback, useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { formatNumber } from "../../../../assets/shared/formatNumber";
import { storageMonedaSigno } from "../../../../assets/shared/sessionData";
import PieChart from "../../../Charts/PieChart";
import Spinner from "../../../UI/Spinner/Spinner";
import { Grid, IconButton, TextField, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { compareByDesc } from "../../../../assets/shared/sorting";
import TablePedidosPendientes from "./TablePedidosPendientes";

const PiePedidosPendientes = (props) => {
  const { pedidos, totalPedidos, loading, noBorder, minHeight, estaOculto } = props;

  const isDisabledChart = estaOculto;
  const [items, setItems] = useState([]);
  const [limit, setLimit] = useState(20);
  const chartSinDatos = pedidos.length === 0 || (pedidos.length === 1 && pedidos[0].value === 0);  

  const pedidosPositivos = useCallback(() => {
    let pedidosPos = pedidos ? pedidos.filter((vnt) => vnt['value'] >= 0) : [];
    return pedidosPos;
  }, [pedidos]);

  const getSeries = useCallback(() => {
    let tempItems = limit && limit > 0 ? items : pedidosPositivos();
    let series = tempItems ? tempItems.map((pedido) => Math.abs(pedido.value)) : [];

    return series;
  }, [limit, items, pedidosPositivos]);

  const getLabels = useCallback(() => {
    let tempItems = limit && limit > 0 ? items : pedidosPositivos();
    let labels = tempItems ? tempItems.map((pedido) => pedido.name) : [];

    return labels;
  }, [limit, items, pedidosPositivos]); 
  
  useEffect(() => {
    if (!loading && limit && limit > 0) {
      let pedidos = pedidosPositivos();
      let ordered = pedidos.sort((a, b) => compareByDesc(a, b, 'monto'));
      let filtered = ordered.slice(0, limit);
      let others = ordered.slice(limit);

      if (others && others.length > 0) {
        let otherItem = {
          mes: others[0].mes,
          anio: others[0].anio,
          monto: 0,
        };
        otherItem['nombre'] = "OTROS";
        otherItem['id'] = "0000";
        others.forEach(element => {
          otherItem.monto += element.monto;
        });
        filtered.splice(0, 0, otherItem);
      }
      setItems(filtered);
    }

  }, [loading, limit, pedidosPositivos]);

  //#region Limit

  const onLimitChange = (value) => {
    let numValue = Number(value);
    setLimit(numValue);
  }

  const getLimit = () => {
    return (
      <Grid container direction='row' justifyContent='center' alignItems='center'>
        <Grid item xs={6}>
          <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
            Límite
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={limit}
            onChange={(event) => onLimitChange(event.target.value)}
            type="number"
            size='small'
            InputProps={{
              inputProps: {
                max: pedidos && pedidos.length,
                min: 0,
                style: { padding: '2px', textAlign: 'center' }
              }
            }}
          />
        </Grid>
        <Grid item xs={2}>
          {limit && limit > 0 ? (
            <IconButton size='small' onClick={() => setLimit(0)}>
              <Close fontSize='small' />
            </IconButton>
          ) : <Fragment></Fragment>}
        </Grid>
      </Grid>
    )
  }

  //#endregion

  //#region Change View
  const [viewAsPie, setViewAsPie] = useState(true);

  const handleChangeView = () => {
    setViewAsPie(!viewAsPie);
  }

  const dataLabels = {
    enabled: true,
    formatter: function (val, opts) {
      let item = opts.w.config.labels[opts.seriesIndex];

      if (item && item.toUpperCase() === 'OTROS')
        return `OTROS ${formatNumber(val)}%`;
      else
        return `${formatNumber(val)}%`;
    },
  }

  const subTitle = () => {
    return `Total: ${storageMonedaSigno()} ${formatNumber(totalPedidos)}`;
  }

  const renderPie = () => {
    return (
      <PieChart
        title={`Pedidos Pendientes`}
        endItems={getLimit()}
        subTitle={subTitle()}
        labels={getLabels()}
        series={getSeries()}
        imgSinDatos={chartSinDatos}
        loading={loading}
        legendPosition={'bottom'}
        chartType="donut"
        legendHorizontalAlign={"left"}
        height={'90%'}
        width={'100%'}
        maxWidthImgSinResult={330}
        noBorder={noBorder}
        minHeight={minHeight}
        onChangeViewClick={handleChangeView}
        dataLabels={dataLabels}
      />
    );
  }

  const renderTable = () => {
    return (
      <TablePedidosPendientes
        title={`Pedidos Pendientes`}
        subTitle={subTitle()}
        pedidos={pedidos}
        totalPedidos={totalPedidos}
        loading={loading}
        onChangeViewClick={handleChangeView}
        height={436}
        disabled={isDisabledChart}
        filename={`Pedidos Pendientes`}
      />
    )
  }

  //#endregion

  return loading ? (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <Spinner />
    </div>
  ) : viewAsPie ? (
    <Fragment>
      {renderPie()}
    </Fragment>
  ) : (
    <Fragment>
      {renderTable()}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    pedidos: state.ventas.estadosPedidosPendientes.pedidos,
    loading: state.ventas.estadosPedidosPendientes.loading,
    totalPedidos: state.ventas.estadosPedidosPendientes.total,
    estaCargado: state.ventas.estadosPedidosPendientes.estaCargado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PiePedidosPendientes);